import { DimensionDto } from "dtos/llm/DimensionDto";
import { ReportCard } from "components/game/ReportCard";
import { IconText } from "components/IconText";
import { ModalButton } from "components/modals/ModalButton";

export const ReportCardModalButton = () => (
    <ModalButton
        id="modal-report-card"
        className="btn btn-dark icon-link"
        text={<IconText icon="fas fa-card-heart" text="View scorecard" />}
    />
);

export const ReportCardModal = (props: { dimensions: Array<DimensionDto>; llmScore: number; playerName: string }) => {
    const { dimensions, llmScore, playerName } = props;

    return (
        <div id="modal-report-card" className="modal" data-bs-keyboard="false">
            <div className="modal-dialog p-3">
                <ReportCard animationStage={999} dimensions={dimensions} llmScore={llmScore} playerName={playerName} />
            </div>
        </div>
    );
};
